export const createCartItem = (product, offer) => {
  const item = {
    fullName: product.fullName,
    image: {
      url: product.images.find((image) => image.isTitle === true).url,
      name: product.images.find((image) => image.isTitle === true).name,
    },
    price: {
      value: offer.price.value,
      currencyIso: offer.price.currencyIso,
    },
    priceId: offer.id,
    quantity: 1,
    ready2Order: true,
    sku: product.sku,
    totalPrice: {
      value: offer.price.value,
      currencyIso: offer.price.currencyIso,
    },
  };

  return item;
};
